import { render, staticRenderFns } from "./bannerstand-banner-widget.vue?vue&type=template&id=2af2d21c"
import script from "./bannerstand-banner-widget.vue?vue&type=script&lang=ts"
export * from "./bannerstand-banner-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports